import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneModificationContainer extends ShadowDOMElement {
	static className = "PersonneModificationContainer";
	
	static properties = {
		name: { type: String, attribute: "name" },
		visible: {
			type: Boolean, attribute: "visible", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRegistrationLocation: { type: Boolean, attribute: "show-registration-location",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.containerId = `content-container-${crypto.randomUUID()}`;
		this.name = `personne-type`;
		this.visible = true;
		this.showRegistrationLocation = true;
	}

	render() {
    return html`
      <div id="${this.containerId}" style="display: ${this.visible ? 'block' : 'none'}">
        <row-wrapper>
          <radio-buttons-field
            name="${this.name}"
            .options="${[
              { title: "Personne physique", value: "physique" },
              { title: "Personne morale", value: "morale" },
            ]}"
            value="physique"
            @change="${this.handleRadioChange}"
          ></radio-buttons-field>
        </row-wrapper>
        <div-container id="physique-container" visible="true">
          <personne-physique-modification></personne-physique-modification>
        </div-container>
        <div-container id="morale-container" visible="false">
          <personne-morale-modification
		  	show-replacement="true"
			show-registration-location="${this.showRegistrationLocation}"></personne-morale-modification>
        </div-container>
      </div>
    `;
	}

	handleRadioChange(event) {
		const selectedValue = event.detail.value;

		const physiqueContainer = this.shadowRoot.querySelector("#physique-container");
		const moraleContainer = this.shadowRoot.querySelector("#morale-container");

		if (physiqueContainer && moraleContainer) {
			if (selectedValue === "physique") {
				physiqueContainer.visible = true;
				moraleContainer.visible = false;
			} else if (selectedValue === "morale") {
				physiqueContainer.visible = false;
				moraleContainer.visible = true;
			} else {
				physiqueContainer.visible = false;
				moraleContainer.visible = false;
			}
		}
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-modification-container", PersonneModificationContainer);
